import { useState } from 'react';
import { Card, Col, Row, getFileViewerUrl } from '@packages/utils';
import { useTheme } from 'styled-components';
import { EIconNames, Icon, SharedIcon } from 'components/Base/Icon';
import Spinner from 'components/Base/Spinner';
import { TResourceItemProps } from './ResourceItem.types';
import RemoveResource from '../RemoveResource';

const ResourceItem = ({
  data,
  elcId,
  isResourceEditable,
}: TResourceItemProps) => {
  const [removeIsLoading, setRemoveIsLoading] = useState<boolean>(false);
  const theme = useTheme();
  const { resourceId, file, isGlobal, elcs } = data;
  // For non-global resources, use the elcId from the resource data
  // For global resources, keep elcId undefined so backend deletes from all ELCs
  const effectiveElcId = elcId || (!isGlobal ? elcs?.[0]?.elcId : undefined);

  return (
    <Col md={8}>
      <Card data-cy="resource-item">
        <Row align="middle" wrap={false}>
          <Col className="mr-1" md={2}>
            {removeIsLoading ? (
              <Spinner spinnerSize={24} color={theme.colorBlackIconColor} />
            ) : (
              <Icon icon={EIconNames.FILE} color={theme.colorBlackIconColor} />
            )}
          </Col>
          <Col md={20}>
            <div
              style={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <a
                target="_blank"
                className="ellipsis"
                style={{
                  color: theme.colorBlackDescription,
                  flex: 1,
                  minWidth: 0,
                  paddingRight: isGlobal ? 24 : 0,
                }}
                href={getFileViewerUrl(file.url)}
                rel="noreferrer"
                data-cy="resource-file-link"
              >
                {file.name}
              </a>
              {isGlobal && (
                <SharedIcon
                  size={18}
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }}
                />
              )}
            </div>
          </Col>
          {isResourceEditable && (
            <RemoveResource
              elcId={effectiveElcId}
              resourceId={resourceId}
              className="ml-auto"
              iconName={EIconNames.DELETE_OUTLINED}
              setRemoveIsLoading={setRemoveIsLoading}
              disabled={isGlobal && !!elcId}
            />
          )}
        </Row>
      </Card>
    </Col>
  );
};

export default ResourceItem;
